var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.50002C2.52575 8.49837 3.04663 8.6007 3.53268 8.80114C4.01872 9.00157 4.46033 9.29614 4.83209 9.66791C5.20386 10.0397 5.49843 10.4813 5.69886 10.9673C5.8993 11.4534 6.00163 11.9743 5.99998 12.5",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C3.85652 5.5 5.63699 6.2375 6.94975 7.55025C8.2625 8.86301 9 10.6435 9 12.5",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.50002C3.44479 1.4973 4.8758 1.78084 6.2104 2.33427C7.54499 2.8877 8.75672 3.70004 9.77561 4.72439C10.8 5.74328 11.6123 6.95501 12.1657 8.2896C12.7192 9.6242 13.0027 11.0552 13 12.5",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5C2.55228 13.5 3 13.0523 3 12.5C3 11.9477 2.55228 11.5 2 11.5C1.44772 11.5 1 11.9477 1 12.5C1 13.0523 1.44772 13.5 2 13.5Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.65c3ed77a24ef1cb8304c40583609384.svg";
export { ForwardRef as ReactComponent };